<template>
    <div class="settings-control">
        <span class="settings-control__label">
            {{ label }}
        </span>

        <div class="settings-control__content" :class="contentClasses">
            <slot />
        </div>
    </div>
</template>

<script>
import { STATE_CLASSES } from '@/data/constants/classes';

export default {
    name: 'settings-control',

    props: {
        label: {
            type: String,
            required: true,
        },

        expand: {
            type: Boolean,
            default: false,
        },
    },

    computed: {
        contentClasses() {
            if (this.expand) return STATE_CLASSES.EXPANDED;

            return '';
        },
    },
};
</script>

<style lang="scss">
.settings-control {
    display: flex;
    align-items: center;

    &__label {
        color: var(--form-labelColor);
        font-size: 13px;
        min-width: 120px;
    }

    &__content {
        display: flex;
        align-items: center;
        position: relative;
        font-weight: 600;
        font-size: 14px;
        padding-right: 10px;

        &.#{ $is-expanded } {
            flex-grow: 1;
        }
    }

    &__value {
        display: inline-block;
        min-width: 70px;
    }

    &__actions {
        position: absolute;
        left: 100%;
        display: flex;
        align-items: center;
    }

    &__color {
        display: flex !important;
        width: 16px;

        &:hover {
            cursor: pointer;
        }
    }

    &__clear {
        padding: 5px;
        margin-left: 5px;
    }

    .dropdown__list {
        min-width: 100px;
    }
}
</style>
